import React, { useState } from "react";

const CookieConsentBanner = () => {
  const [consentGiven, setConsentGiven] = useState(() => {
    return document.cookie.indexOf("cookieConsent=accepted") !== -1;
  });

  const acceptCookies = () => {
    setConsentGiven(true);
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    document.cookie = `cookieConsent=accepted; expires=${expirationDate.toUTCString()}; path=/`;
  };

  // Remove loading state since we're checking consent immediately
  if (consentGiven) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <p>
        We use cookies on our website to give you the most relevant experience
        by remembering your preferences and repeat visits.
      </p>
      <p>
        By continuing to use our website, you agree to our use of cookies in
        accordance with our{" "}
        <a
          href="https://www.yellowdoorenergy.com/policies"
          style={{ color: "#ffcc00", textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          cookies and privacy policies
        </a>
        .{" "}
        <button
          onClick={acceptCookies}
          className="cookie-consent-banner-button"
        >
          Agree
        </button>
      </p>
    </div>
  );
};

export default CookieConsentBanner;
